export const CompanySizeOptionKey = [
  "1 (GT 10,000 emp)",
  "2 (5,000-10,000 emp)",
  "3 (1,000-5,000 emp)",
  "4 (500-1,000 emp)",
  "5 (100-500 emp)",
  "6 (50-100 emp)",
  "7 (50-25 emp)",
  "8 (LT 25 emp)"
] as const;

export type CompanySizeOptionKey = typeof CompanySizeOptionKey[number];

export type CompanySizeOptionsObject = {
  readonly [Key in  CompanySizeOptionKey]: string
};